// XML syntax highlighter, returns HTML string
export function hlXML(raw: string): string {
  if (!raw) return "";
  const esc = (s: string) =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

  return raw
    .split("\n")
    .map((line) => {
      if (!line.trim()) return "";
      // Comments
      if (/^\s*<!--/.test(line)) return `<span class="hl-cmt">${esc(line)}</span>`;
      if (/^\s*<\?/.test(line)) return `<span class="hl-cmt">${esc(line)}</span>`;

      let s = esc(line);
      // Tag names
      s = s.replace(
        /(&lt;\/?)([\w:.-]+)/g,
        (_, bracket, tag) => `<span class="hl-br">${bracket}</span><span class="hl-tag">${tag}</span>`
      );
      // Attributes
      s = s.replace(
        /([\w:-]+)(=)(&quot;[^&]*&quot;)/g,
        (_, attr, eq, val) => `<span class="hl-attr">${attr}</span>${eq}<span class="hl-val">${val}</span>`
      );
      // Closing brackets
      s = s.replace(/(\/?&gt;)/g, '<span class="hl-br">$1</span>');
      // Text content between tags
      s = s.replace(
        /(&gt;)([^<&\n]+)(&lt;)/g,
        (_, open, text, close) => `${open}<span class="hl-txt">${text}</span>${close}`
      );
      return s;
    })
    .join("\n");
}
